// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6951fe47] .el-input__inner{height:30px;width:360px}[data-v-6951fe47] .el-form{max-height:157px}.el-form-item__label[data-v-6951fe47]{word-break:normal}", ""]);
// Exports
module.exports = exports;
